import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { components } from '../../../schema/backend';
import { Router } from '@angular/router';
import { FileSystemService } from '../../../services/file-system.service';
import { Usdm2Service } from '../../../services/ai/usdm2.service';
import { ToastService } from '../../../services/toast.service';
import { NgClass } from '@angular/common';
import { ProgressBarModule } from 'primeng/progressbar';
// For dynamic progressbar demo
import { ToastModule } from 'primeng/toast';

type UsdmWorkflowState = components['schemas']['UsdmWorkflowState-Output'];

@Component({
  selector: 'app-usdm-validation',
  imports: [NgClass, ProgressBarModule, ToastModule],
  templateUrl: './usdm-validation.component.html',
  styleUrl: './usdm-validation.component.css',
})
export class UsdmValidationComponent implements OnInit {
  app_state: UsdmWorkflowState | null = null;

  usdmjson: any = null;
  disableDownload: boolean = true;
  progress: number = 0;

  validationSteps: { name: string; status: string }[] = [
    { name: 'Compliance', status: 'not started' },
    { name: 'Mandatory fields', status: 'not started' },
    { name: 'Data integrity', status: 'not started' },
    { name: 'Format standards', status: 'not started' },
    { name: 'Completeness', status: 'not started' },
  ];

  constructor(private http: HttpClient, private router: Router, private fs: FileSystemService, private usdm: Usdm2Service, private toast: ToastService) { }

  ngOnInit(): void {
    this.validateUsdm();
  }

  async openViewer() {
    await this.fs.refreshRootNode();
    const filePath = `${this.fs.rootNode.path}/${this.usdm.protocol?.path.split('/').pop()?.replace('.pdf', '') || 'usdm'}.json`;
    const node = this.fs.rootNode.getNode(filePath);
    if (!node) {
      this.toast.showError('File not found in the file system. Please download the USDM json file first.');
      return;
    }
    const blob = await node.getBlob();
    if (blob) {
      const blobUrl = URL.createObjectURL(blob);
      window.open(this.router.createUrlTree(['/usdm-viewer'], { queryParams: { blobUrl } }).toString(), '_blank');
    }
  }

  downloadUsdm() {
    this.http.get(`${environment.osburl}/api/usdm/v3/studyDefinitions/${this.usdm.privateOsbStudyId}`, { responseType: 'blob' }).subscribe((response: Blob) => {
      new Response(response).json().then(json => {
        this.usdmjson = json;
        if (this.usdm.criteria) {
          this.usdmjson.study.versions[0].eligibilityCriterionItems = this.usdm.criteria.eligibilityCriterionItems;
          // console.log(this.usdmjson.study.versions[0].eligibilityCriterionItems);
          this.usdmjson.study.versions[0].studyDesigns[0].eligibilityCriteria = this.usdm.criteria.eligibilityCriteria;
          // console.log(this.usdmjson.study.versions[0].studyDesigns[0].eligibilityCriteria);
        }
        console.log(this.usdmjson);
        this.fs.uploadFiles([new File([JSON.stringify(this.usdmjson)], `${this.usdm.protocol?.path.split('/').pop()?.replace('.pdf', '') || 'usdm'}.json`, { type: 'application/json' })], this.fs.rootNode);
        this.fs.refreshRootNode();
        this.toast.showSuccess('USDM json file downloaded successfully.');
      });
    });
  }

  async validateUsdm() {
    for (const step of this.validationSteps) {
      step.status = 'in progress';
      await new Promise(resolve => setTimeout(resolve, 3000));
      step.status = 'completed';
      this.progress += 20;
    }
    this.disableDownload = false;
  }
}
